import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/dymaczew/Documents/_code/mcm/cp4mcm-demohub/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`Cloud Pak for Multicloud Management Labs Environments`}</h2>
    <p>{`The DTE Team provides the ability to provision learning environment with the Cloud Pak for Multicloud Management 2.x installed running on Red Hat OpenShift.`}</p>
    <p>{`There are two different options, as described in the picture below:`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "44.09722222222222%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAJCAYAAAAywQxIAAAACXBIWXMAAAsSAAALEgHS3X78AAAB7UlEQVQoz3WST2gTQRTGFwR70pYqCnoSMRYUxIuKJ1uh4sWbeFEPnhQUSSkWkaKHSL2I9VKQgoJQ8B9IhVJrQAhJY6P4J4FGrZq6Ndsm2cRk2yS7zWTzc2dj2lLtB2/mzQzve2/e95RarYY0iZW+hG3bS37RFKTyZSqiyv/QiFPk3iBaJraxq8L1vydLdA2EOdztp+3CCMduBDndN8arUBQta/AxOU/KsGSUG6+woqIGmUS9jiKPnj9G2XGVDQd9tHbcZVOHD2XLcfrvD/NZF0QSBomsRbme36nQWeatKqlUioyecy8XF2YoTXnhyx6CQ7vZ1e5l4/4emh1r2nmS5rYTBCKTTKcLfE3MkMlkSGqzmKbpENqL2IUQIj+ByAUdugx5LUb4YSffnm0lPdLKS982th+4SNNeL0dO9XLOe4sf6hx6epZweJxYLIqqqgghnC9jY+hxdIckq30grcUxfqcZG+pj9M5RAr3rGO1qwXPoLMrmM5zv6WfiXdQVp1IRFIslLMtaapkil5+qRuTteybjU6i/5rCFReD2PoavrMd/rQX/ZYUn3R681wd58PT1mirXRXFgmmWyWd3JtuCqJVHQPjE+0M6LSwqhmx7KyTf/BK+2v2OzWuVlpeWbGr5HOTftnmWP5GyuNbcSfwA4hW+Jj6w5gAAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "labs-options",
        "title": "labs-options",
        "src": "/cp4mcm-demohub/static/663fb923dcc15fa28b649d0484ce82ec/3cbba/labs-options.png",
        "srcSet": ["/cp4mcm-demohub/static/663fb923dcc15fa28b649d0484ce82ec/7fc1e/labs-options.png 288w", "/cp4mcm-demohub/static/663fb923dcc15fa28b649d0484ce82ec/a5df1/labs-options.png 576w", "/cp4mcm-demohub/static/663fb923dcc15fa28b649d0484ce82ec/3cbba/labs-options.png 1152w", "/cp4mcm-demohub/static/663fb923dcc15fa28b649d0484ce82ec/7d50b/labs-options.png 1724w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <p>{`The options are different in capabilities, features and use cases. Next page, you will understand the pros, cons and use case of each option, to help you to select the best option for your demand.`}</p>
    <p>{`Both environments are dedicated/personal environments with no extra cost for you.`}</p>
    <p>{`In this tutorial, you have all the documentation to request and prepare both options. Each environment has a collection of pre-created labs to be used in a self-study scenario or in a hands-on event. The labs are not the same, because the environments have different capabilities. Check each environment page, to see the list of labs available.`}</p>
    <p>{`After you follow this documentation, you will have a Cloud Pak for Multicloud Management 2.x environment. During the reservation process, you are able to define the expiration date of your environment, max of 14 days (with some options to extend it).`}</p>
    <p>{`If you have any issues or feedback, please share it with the tutorial authors. Enjoy it!!`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      